<template>
    <div class="careerList"  @click="detailLink(careerInfo.j_id)">
        <p><span>{{$t('job_title')}}</span>{{careerInfo.title}}</p>
        <p><span>{{$t('depart')}}</span>{{careerInfo.company}}</p>
        <p><span>{{$t('work_address')}}</span>{{careerInfo.experience}}</p>
        <p><span>{{$t('recruitment_number')}}</span>{{careerInfo.count}}</p>
        <p><span>{{$t('release_time')}}</span>{{careerInfo.uptime}}</p>
    </div>
</template>

<script>
    export default {
        name: "careerList",
        props:['careerInfo'],
        created:function () {
        },
        methods:{
            detailLink (id) {
                this.$router.push({path: `/joinUsDetail/${id}`,})
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/less/common.less";
    .careerList {
        .border-radius(9px);
        .box-shadow;
        .box-sizing;
        width: @width;
        padding: 5%;
        margin-bottom: 5%;
        p {
            line-height: 2rem;
            font-size: @font;
            span {
                color: @word;
                margin-right: 3%;
            }
        }
    }

</style>
